import { watch, onMounted } from "vue";
import { useNotificationStore } from "../stores/notificationStore";
import { useAuthStore } from "@/new_design/auth/stores/auth";

export function useNotificationSetup() {
  const store = useNotificationStore();
  const authStore = useAuthStore();

  // Verificar permisos al montar el componente
  onMounted(async () => {
    await store.checkPermission();
  });

  // Inicializar las notificaciones cuando el usuario esté autenticado
  watch(
    () => authStore.userId,
    async (userId) => {
      if (!userId) {
        // Si no hay userId, reiniciamos el estado
        store.isInitialized = false;
        return;
      }

      await store.checkPermission();
      await store.initializeNotifications(userId);
    },
    { immediate: true }
  );

  // Manejar cambios en el estado de autenticación
  watch(
    () => authStore.isAuthenticated,
    async (isAuthenticated) => {
      if (!isAuthenticated) {
        // Si el usuario se desautentica, reiniciamos el estado
        store.isInitialized = false;
        return;
      }

      if (authStore.userId) {
        await store.initializeNotifications(authStore.userId);
      }
    }
  );

  return {
    store,
  };
}
